<template>
  <div class="transaction-detail-content">
    <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/firewall' }"
        >Firewall</el-breadcrumb-item
      >
      <el-breadcrumb-item>Firewall detail</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><svg-icon icon-class="firewall" /> Firewall Detail</span>
        <div style="float: right"></div>
      </div>

      <div v-loading="loading">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <!-- <el-tag style="margin-bottom: 10px" v-if="detailData.hitReason">Reason: {{ detailData.hitReason }}</el-tag> -->

            <el-alert
              v-if="detailData.hitReason"
              title="Alert Trigger Type"
              type="warning"
              :description="detailData.hitReason"
              show-icon
              :closable="false"
              class="transaction-detail-alert"
            >
            </el-alert>
            <!-- <el-alert
              :title="detailData.memberCode"
              type="success"
              :description="detailData.bankholderId"
              :closable="false"
              class="transaction-detail-alert"
            >
            </el-alert> -->
            <el-descriptions
              :column="1"
              border
              size="mini"
              style="margin-bottom: 16px"
              :label-style="{
                'background-color': '#f0f9eb',
                color: '#67C23A',
                width: '180px',
              }"
            >
              <el-descriptions-item label="Customer Legal Name">
                {{ detailData.customerName }}
              </el-descriptions-item>
              <el-descriptions-item label="Customer ID">
                {{ detailData.memberCode }}
              </el-descriptions-item>

              <el-descriptions-item label="Review name">
                {{ detailData.approveUser }}
              </el-descriptions-item>
              <el-descriptions-item label="Date">
                {{ dateFormat(detailData.approveDate) }}
              </el-descriptions-item>
              <el-descriptions-item label="BankHolderID">
                {{ detailData.bankholderId }}
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions
              class="margin-top"
              title="Transaction detail"
              :column="1"
              border
              style="margin-bottom: 16px"
              :label-style="{ width: '180px' }"
              size="mini"
            >
              <template slot="extra">
                <el-button
                  v-if="detailData.status === 'wait'"
                  type="success"
                  size="small"
                  @click="approveStatus()"
                  >Approve</el-button
                >
                <el-button
                  v-if="detailData.status === 'wait'"
                  type="danger"
                  size="small"
                  @click="declineStatus()"
                  >Decline</el-button
                >

                <el-button
                  size="small"
                  type="primary"
                  @click="exportProfile()"
                  icon="el-icon-download"
                  style="margin-left: 20px"
                >
                  Export Profile
                </el-button>
              </template>
              <el-descriptions-item label="Case ID">
                {{ detailData.caseId }}
              </el-descriptions-item>
              <el-descriptions-item label="Create">
                {{ dateFormat(detailData.createdDate) }}
              </el-descriptions-item>
              <el-descriptions-item label="Payment Type">
                <el-tag
                  size="small"
                  v-if="detailData.paymentType == 'payout'"
                  type="warning"
                  >{{ detailData.paymentType }}</el-tag
                >
                <el-tag size="small" v-if="detailData.paymentType == 'payin'">{{
                  detailData.paymentType
                }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="Status">
                <el-tag
                  size="small"
                  type="success"
                  v-if="detailData.status === 'approve'"
                  >{{ detailData.status }}</el-tag
                >
                <el-tag
                  size="small"
                  type="danger"
                  v-if="detailData.status === 'decline'"
                  >{{ detailData.status }}</el-tag
                >
                <el-tag
                  size="small"
                  type="info"
                  v-if="detailData.status === 'wait'"
                  >{{ detailData.status }}</el-tag
                >
                <el-tag size="small" v-if="detailData.status === 'OK'">{{
                  detailData.status
                }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="Member Code">
                <el-tag size="small">{{ detailData.memberCode }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="BankholderID">
                <el-tag size="small">{{ detailData.bankholderId }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="Sender Name">
                {{ detailData.senderName }}
              </el-descriptions-item>
              <el-descriptions-item label="Sender Acc No./IBAN">
                {{ detailData.senderAccountnumberIban }}
              </el-descriptions-item>
              <el-descriptions-item label="Sender Sortcode/BIC">
                {{ detailData.senderSortcodeBic }}
              </el-descriptions-item>
              <el-descriptions-item label="Payee Name">
                {{ detailData.payeeName }}
              </el-descriptions-item>
              <el-descriptions-item label="Payee Acc No./IBAN">
                {{ detailData.payeeAccountnumberIban }}
              </el-descriptions-item>
              <el-descriptions-item label="Payee Sortcode/BIC">
                {{ detailData.payeeSortcodeBic }}
              </el-descriptions-item>
              <el-descriptions-item label="Amount">
                {{ detailData.amount }} {{ detailData.currency }}
              </el-descriptions-item>

              <el-descriptions-item label="Reference">
                {{ detailData.reference }}
              </el-descriptions-item>
              <el-descriptions-item
                label="Comment"
                content-class-name="comment-content"
              >
                <pre>{{ detailData.comment }}</pre>
              </el-descriptions-item>
              <el-descriptions-item label="Update">
                {{ dateFormat(detailData.updatedDate) }}
              </el-descriptions-item>
              <el-descriptions-item label="User">
                {{ detailData.updateUsername }}
              </el-descriptions-item>
              <el-descriptions-item label="Plus UID">
                {{ detailData.plusuid }}
              </el-descriptions-item>
              <el-descriptions-item label="Reason" v-if="detailReport">
                {{ detailReport.reason }}
              </el-descriptions-item>
              <el-descriptions-item label="Criteria Number" v-if="detailReport">
                <el-tag
                  size="small"
                  type="danger"
                  v-if="detailReport.numberMatch"
                  >{{ detailReport.numberMatch }}</el-tag
                >
              </el-descriptions-item>
              <el-descriptions-item label="Criteria Text" v-if="detailReport">
                <el-tag
                  size="small"
                  type="danger"
                  v-if="detailReport.stringMatch"
                  >{{ detailReport.stringMatch }}</el-tag
                >
              </el-descriptions-item>
            </el-descriptions>

            <el-card
              class="box-card"
              shadow="never"
              v-if="detailReport && detailReport.queryResult.length > 0"
            >
              <div slot="header" class="clearfix">
                <span
                  ><i class="el-icon-date"></i> Report under scope rule</span
                >
              </div>

              <el-table
                :data="detailReport.queryResult"
                border
                size="mini"
                style="width: 100%"
              >
                <el-table-column
                  prop="caseId"
                  label="Case ID"
                  width="80"
                  header-align="center"
                  align="center"
                  fixed="left"
                ></el-table-column>
                <el-table-column
                  prop="createdDate"
                  label="Date"
                  width="110"
                  header-align="center"
                  align="center"
                  fixed="left"
                ></el-table-column>
                <el-table-column
                  prop="totalSummary"
                  label="Accumulate"
                  width="120"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="count"
                  label="Count"
                  width="80"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="bankholderId"
                  label="Bankholder"
                  width="110"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="hitReason"
                  label="Reason"
                  min-width="200"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="amount"
                  label="Amount"
                  width="80"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="currency"
                  label="Currency"
                  width="80"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="status"
                  label="Status"
                  width="100"
                  header-align="center"
                  align="center"
                ></el-table-column>

                <el-table-column
                  prop="payeeName"
                  label="Name"
                  width="180"
                  header-align="center"
                  align="center"
                  v-if="detailData.paymentType == 'payout'"
                ></el-table-column>
                <el-table-column
                  prop="payeeAccountnumberIban"
                  label="Acc/IBAN"
                  width="180"
                  header-align="center"
                  align="center"
                  v-if="detailData.paymentType == 'payout'"
                ></el-table-column>
                <el-table-column
                  prop="payeeSortcodeBic"
                  label="Sortcode/BIC"
                  width="180"
                  header-align="center"
                  align="center"
                  v-if="detailData.paymentType == 'payout'"
                ></el-table-column>

                <el-table-column
                  prop="senderName"
                  label="Name"
                  width="180"
                  header-align="center"
                  align="center"
                  v-if="detailData.paymentType == 'payin'"
                ></el-table-column>
                <el-table-column
                  prop="senderAccountnumberIban"
                  label="Acc/IBAN"
                  width="180"
                  header-align="center"
                  align="center"
                  v-if="detailData.paymentType == 'payin'"
                ></el-table-column>
                <el-table-column
                  prop="senderSortcodeBic"
                  label="Sortcode/BIC"
                  width="180"
                  header-align="center"
                  align="center"
                  v-if="detailData.paymentType == 'payin'"
                ></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span
                  ><i class="el-icon-s-comment"></i> Investigation Summary</span
                >
              </div>
              <div v-loading="submittingComment">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="Comment"
                  v-model="comment"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-top: 16px"
                  @click="submitComment"
                >
                  Submit
                </el-button>
                <el-button
                  type="info"
                  size="small"
                  style="margin-top: 16px"
                  @click="cancelAddTransactionComment"
                >
                  Cancel
                </el-button>
              </div>

              <div
                style="margin-top: 20px; min-height: 200px"
                v-loading="loading"
              >
                <div
                  v-for="item of commentList"
                  :key="item.uid"
                  :class="
                    `card-comment ${item.user === 'auto' ? 'auto-upload' : ''}`
                  "
                >
                  <el-row :gutter="1">
                    <el-col :xs="24" :sm="16" :md="24" :lg="16">
                      <div v-loading="item.submitting">
                        <pre v-if="!item.editing" class="message-comment">{{
                          item.comment
                        }}</pre>
                        <div
                          v-else
                          style="margin-top: 15px; margin-bottom: 15px;"
                        >
                          <el-input
                            type="textarea"
                            autosize
                            size="mini"
                            placeholder="Comment"
                            v-model="item.comment"
                          ></el-input>
                          <el-button
                            type="primary"
                            size="mini"
                            style="margin-top: 6px"
                            @click="updateTransactionComment(item)"
                          >
                            Submit
                          </el-button>
                          <el-button
                            type="info"
                            size="mini"
                            style="margin-top: 6px"
                            @click="cancelUpdateTransactionComment(item)"
                          >
                            Cancel
                          </el-button>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="24" :lg="8">
                      <div class="info-comment">
                        <div style="margin-bottom: 5px;">
                          by {{ item.user }}
                        </div>
                        {{ dateFormat(item.createdDate) }}
                        <span v-if="item.canEdit">
                          <span
                            class="edit-comment"
                            @click="editTransactionComment(item)"
                            ><i class="el-icon-edit"></i
                          ></span>
                          <span
                            class="delete-comment"
                            @click="deleteTransactionComment(item)"
                            ><i class="el-icon-delete"></i
                          ></span>
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span><i class="el-icon-success"></i> Check</span>
              </div>
              <div>
                <el-descriptions
                  :column="1"
                  border
                  size="mini"
                  :content-style="{ 'text-align': 'center' }"
                >
                  <el-descriptions-item label="Request for information?">
                    <el-tag
                      size="small"
                      :type="detailData.fileupload ? 'success' : 'danger'"
                    >
                      {{ detailData.fileupload ? "Y" : "N" }}
                    </el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="Escalation to MLRO required?">
                    <el-tag
                      size="small"
                      :type="detailData.sar_report ? 'success' : 'danger'"
                    >
                      {{ detailData.sar_report ? "Y" : "N" }}
                    </el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="Any other red flags identified?">
                    <el-tag
                      size="small"
                      :type="
                        detailData.other_redflags_identified
                          ? 'success'
                          : 'danger'
                      "
                    >
                      {{ detailData.other_redflags_identified ? "Y" : "N" }}
                    </el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="Has all the relevant document been filed?"
                  >
                    <el-tag
                      size="small"
                      :type="
                        detailData.fileupload_approve ? 'success' : 'danger'
                      "
                    >
                      {{ detailData.fileupload_approve ? "Y" : "N" }}
                    </el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="Has the log been updated?">
                    <el-tag
                      size="small"
                      :type="detailData.indentity_expire ? 'success' : 'danger'"
                    >
                      {{ detailData.indentity_expire ? "Y" : "N" }}
                    </el-tag>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-card>
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span
                  ><i class="el-icon-upload"></i> Support documents source of
                  wealth
                </span>
              </div>
              <div>
                <el-upload
                  :action="actionUpload"
                  drag
                  :auto-upload="true"
                  :on-success="onSuccessUpload"
                  :file-list="fileList.sourceOfWealth"
                  accept=".png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.pdf,.zip,.rar"
                  :headers="headerUpload"
                  name="transaction_files"
                  :data="{ type: 'sourceOfWealth' }"
                  :multiple="true"
                >
                  <el-button size="small" type="primary"
                    >Click / Drop to upload</el-button
                  >

                  <div slot="file" slot-scope="{ file }">
                    <a class="el-upload-list__item-name">
                      <span class="file-download" @click="fileDownload(file)"
                        ><i class="el-icon-download"></i></span
                      ><i :class="file.icon"></i>
                      <span @click="filePreview(file)">{{
                        file.filename
                      }}</span>
                      <span class="file-delete" @click="fileRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </a>
                  </div>
                </el-upload>
              </div>
            </el-card>
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span
                  ><i class="el-icon-upload"></i> Support purpose of payment
                  documents</span
                >
              </div>
              <div>
                <el-upload
                  :action="actionUpload"
                  drag
                  :auto-upload="true"
                  :on-success="onSuccessUpload"
                  :file-list="fileList.purposeOfPayment"
                  accept=".png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.pdf,.zip,.rar"
                  :headers="headerUpload"
                  name="transaction_files"
                  :data="{ type: 'purposeOfPayment' }"
                  :multiple="true"
                >
                  <el-button size="small" type="primary"
                    >Click / Drop to upload</el-button
                  >

                  <div slot="file" slot-scope="{ file }">
                    <a class="el-upload-list__item-name">
                      <span class="file-download" @click="fileDownload(file)"
                        ><i class="el-icon-download"></i></span
                      ><i :class="file.icon"></i>
                      <span @click="filePreview(file)">{{
                        file.filename
                      }}</span>
                      <span class="file-delete" @click="fileRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </a>
                  </div>
                </el-upload>
              </div>
            </el-card>
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span
                  ><i class="el-icon-s-comment"></i> Additional Commentary</span
                >
              </div>
              <div>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="Comment"
                  v-model="commentary"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-top: 16px"
                  :loading="submittingCommentary"
                  @click="submitAdditionalComment"
                >
                  Submit
                </el-button>
                <el-button
                  type="info"
                  size="small"
                  style="margin-top: 16px"
                  @click="cancelAdditionalComment"
                >
                  Cancel
                </el-button>
              </div>
              <div
                style="margin-top: 20px; min-height: 200px"
                v-loading="loading"
              >
                <div
                  v-for="item of commentAdditionalList"
                  :key="item.uid"
                  :class="
                    `card-comment ${item.user === 'auto' ? 'auto-upload' : ''}`
                  "
                >
                  <el-row :gutter="1">
                    <el-col :xs="24" :sm="16" :md="24" :lg="16">
                      <div v-loading="item.submitting">
                        <pre v-if="!item.editing" class="message-comment">{{
                          item.comment
                        }}</pre>
                        <div
                          v-else
                          style="margin-top: 15px; margin-bottom: 15px;"
                        >
                          <el-input
                            type="textarea"
                            autosize
                            size="mini"
                            placeholder="Comment"
                            v-model="item.comment"
                          ></el-input>
                          <el-button
                            type="primary"
                            size="mini"
                            style="margin-top: 6px"
                            @click="updateAdditionalComment(item)"
                          >
                            Submit
                          </el-button>
                          <el-button
                            type="info"
                            size="mini"
                            style="margin-top: 6px"
                            @click="cancelUpdateAdditionalComment(item)"
                          >
                            Cancel
                          </el-button>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="24" :lg="8">
                      <div class="info-comment">
                        <div style="margin-bottom: 5px;">
                          by {{ item.user }}
                        </div>
                        {{ dateFormat(item.createdDate) }}
                        <span v-if="item.canEdit">
                          <span
                            class="edit-comment"
                            @click="editAdditionalComment(item)"
                            ><i class="el-icon-edit"></i
                          ></span>
                          <span
                            class="delete-comment"
                            @click="deleteAdditionalComment(item)"
                            ><i class="el-icon-delete"></i
                          ></span>
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>

            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span><i class="el-icon-s-check"></i> MLRO</span>
              </div>
              <div>
                <h4 style="color: #f56c6c;" v-if="detailData.sar_report">
                  Compliance Report Case ID
                  {{ detailData.complianceReportCaseId }}
                </h4>
                <p style="color: #f56c6c; font-size: 15px">
                  <b
                    >The follow alerts must be escalated to the MLRO regardless
                    of the review outcome:</b
                  >
                </p>
                <ul style="color: #f56c6c; font-size: 14px">
                  <li>Cash related transaction</li>
                  <li>PEP & Sanctions</li>
                  <li>Sanctions/Prohibited Countries</li>
                </ul>

                <div v-if="!detailData.sar_report">
                  <el-select
                    v-model="detailData.sar_activity_type"
                    placeholder="Select"
                    style="margin-right: 10px"
                  >
                    <el-option
                      label="Cash related transaction"
                      value="Cash related transaction"
                    >
                    </el-option>
                    <el-option label="PEP & Sanctions" value="PEP & Sanctions">
                    </el-option>
                    <el-option
                      label="Sanctions/Prohibited Countries"
                      value="Sanctions/Prohibited Countries"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    type="primary"
                    :loading="submittingSarReport"
                    @click="submitSarReport"
                    >Escalated to the MLRO</el-button
                  >
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-dialog :visible.sync="dialogVisible">
      <img style="width: 100%; height: auto" :src="dialogImageUrl" />
    </el-dialog>

    <el-dialog :visible.sync="dialogDeclineIFX" title="Account Detail" width="40%">
      <el-form ref="declineForm" :model="declineFormIFX" :rules="ruleDeclineFormIFX" label-position="top">
        <div v-if="detailData.currency === 'GBP'">
          <el-form-item label="Account number" prop="payinAccountnumber">
            <el-input v-model="declineFormIFX.payinAccountnumber"></el-input>
          </el-form-item>
          <el-form-item label="Sortcode" prop="payinSortcode">
            <el-input v-model="declineFormIFX.payinSortcode"></el-input>
          </el-form-item>
          <el-form-item label="Swiftbic" prop="payinSwiftbic">
            <el-input v-model="declineFormIFX.payinSwiftbic"></el-input>
          </el-form-item>
        </div>

        <div v-else>
          <el-form-item label="IBAN" prop="payiniban">
            <el-input v-model="declineFormIFX.payiniban"></el-input>
          </el-form-item>
          <el-form-item label="Swiftbic" prop="payinSwiftbic">
            <el-input v-model="declineFormIFX.payinSwiftbic"></el-input>
          </el-form-item>
          <el-form-item label="Country Code" prop="payinCountrycode">
            <el-select style="width:100%" v-model="declineFormIFX.payinCountrycode" filterable placeholder="Select">
              <el-option
                v-for="(item, index) in country"
                :key="index"
                :label="`${getFlagEmoji(item.country_code)}  ${item.country_name}`"
                :value="item.country_code">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button @click="dialogDeclineIFX=false">Cancel</el-button>
          <el-button type="primary" @click="submitDeclineForm()" :loading="loading">Submit</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import {
  getTransactionID,
  getTransactionIDComment,
  postTransactionIDComment,
  updateTransactionCommentByUID,
  deleteTransactionCommentByUID,
  putTransactionID,
  deleteTransactionIDdocument,
  getTransactionIDdocument,
  reportFirewallProfile,
  postTransactionIDAdditionalComment,
  getTransactionIDAdditionalComment,
  updateTransactionIDAdditionalCommentByUID,
  deleteTransactionIDAdditionalCommentByUID,
  postTransactionIDCheckSarReport,
} from "@/api/firewall";
import { getFirewallTransactionsDetail } from "@/api/firewall-report";
import { dateFormat } from "@/utils";
import { getUtility } from "@/api/customer";
export default {
  computed: {
    username() {
      return this.$store.state.user.fullname;
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      dialogDeclineIFX: false,
      disabled: false,
      loading: false,
      submittingComment: false,
      submittingCommentary: false,
      submittingSarReport: false,
      comment: "",
      commentary: "",
      actionUpload: `${
        process.env.VUE_APP_SERVER_BASE_API
      }/api/firewall/transactions/${this.$route.params.transactionid}/document`,
      headerUpload: {
        authorization: getToken(),
      },
      mlro: "",
      detailData: {
        caseId: "",
        amount: "",
        bankholderId: "",
        comment: "",
        createdDate: "",
        currency: "",
        firewallHit: false,
        memberCode: "",
        customerName: "",
        payeeAccountnumberIban: "",
        payeeName: "",
        payeeSortcodeBic: "",
        paymentType: "",
        paymentuid: "",
        plusuid: "",
        senderAccountnumberIban: "",
        senderName: "",
        senderSortcodeBic: "",
        status: "",
        updateUsername: "",
        updatedDate: null,
        hitReason: "",
        fileupload: 0,
        sar_report: 0,
        sar_activity_type: "",
        other_redflags_identified: 0,
        fileupload_approve: 0,
        indentity_expire: 0,
        additional_commentary: "",
        complianceReportCaseId: "",
        vender: "",
      },
      detailReport: null,
      fileList: {
        purposeOfPayment: [],
        sourceOfWealth: [],
      },
      commentList: [],
      commentAdditionalList: [],
      contentType: {
        xlsx: "application/vnd.openxmlformats-officedocument.spre",
        docx: "application/vnd.openxmlformats-officedocument.word",
        pdf: "application/pdf",
        png: "image/png",
        jpg: "image/jpeg",
        zip: "application/zip",
        rar: "application/x-rar-compressed",
      },
      declineFormIFX: {
        status: "",
        payinAccountnumber: "",
        payinSortcode: "",
        payiniban: "",
        payinSwiftbic: "",
        payinCountrycode: "",
      },
      ruleDeclineFormIFX: {
        payinAccountnumber: [
          {
            required: true,
            message: "Please input Account number",
            trigger: "blur",
          },
        ],
        payinSortcode: [
          { required: true, message: "Please input Sortcode", trigger: "blur" },
        ],
        payiniban: [
          { required: true, message: "Please input IBAN", trigger: "blur" },
        ],
        payinSwiftbic: [
          {
            required: true,
            message: "Please input Swift BIC",
            trigger: "blur",
          },
        ],
        payinCountrycode: [
          {
            required: true,
            message: "Please input Country Code",
            trigger: "blur",
          },
        ],
      },
      country: [],
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.country = data.country.filter((country) => country.country_code != '');
        }
      });
    },
    getFlagEmoji(countryCode) {
      if (!countryCode) return '';
      // แปลงเป็น Emoji ธง
      return countryCode
        .toUpperCase()
        .replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397));
    },
    getDetail() {
      this.loading = true;
      getTransactionID(this.$route.params.transactionid).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.detailData.caseId = data.caseId;
            this.detailData.amount = data.amount;
            this.detailData.bankholderId = data.bankholderId;
            this.detailData.comment = data.comment;
            this.detailData.createdDate = data.createdDate;
            this.detailData.currency = data.currency;
            this.detailData.firewallHit = data.firewallHit;
            this.detailData.memberCode = data.memberCode;
            this.detailData.customerName = data.customerName;
            this.detailData.payeeAccountnumberIban =
              data.payeeAccountnumberIban;
            this.detailData.payeeName = data.payeeName;
            this.detailData.payeeSortcodeBic = data.payeeSortcodeBic;
            this.detailData.paymentType = data.paymentType;
            this.detailData.paymentuid = data.paymentuid;
            this.detailData.plusuid = data.plusuid;
            this.detailData.senderAccountnumberIban =
              data.senderAccountnumberIban;
            this.detailData.senderName = data.senderName;
            this.detailData.senderSortcodeBic = data.senderSortcodeBic;
            this.detailData.status = data.status;
            this.detailData.updateUsername = data.updateUsername;
            this.detailData.updatedDate = data.updatedDate;
            this.detailData.approveUser = data.approveUser || "";
            this.detailData.approveDate = data.approveDate || "";
            this.detailData.hitReason = data.hitReason;
            this.detailData.fileupload = data.fileupload;
            this.detailData.sar_report = data.sar_report;
            this.detailData.sar_activity_type = data.sar_activity_type;
            this.detailData.other_redflags_identified =
              data.other_redflags_identified;
            this.detailData.fileupload_approve = data.fileupload_approve;
            this.detailData.indentity_expire = data.indentity_expire;
            this.detailData.additional_commentary = data.additional_commentary;
            this.detailData.vender = data.vender || "ifx";
            this.detailData.complianceReportCaseId =
              data.complianceReportCaseId || "";

            this.declineFormIFX.status = data.status || "";

            if(data.accountDetail){
              this.declineFormIFX.payinAccountnumber = data.accountDetail.payinAccountnumber || "";
              this.declineFormIFX.payinSortcode = data.accountDetail.payinSortcode || "";
              this.declineFormIFX.payinSwiftbic = data.accountDetail.payinSwiftbic || "";
              this.declineFormIFX.payiniban = data.accountDetail.payiniban || "";
              this.declineFormIFX.payinCountrycode = data.accountDetail.payinCountrycode || "";
            }
            

            this.commentary = data.additional_commentary;
            this.getFileLists(data.plusuid);
            this.getComment();
            this.getAdditionalComment();
            this.getReport();
          }
        }
      );
    },
    fileRemove(file) {
      this.$confirm(
        `This will delete file ${file.name}. Continue?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          deleteTransactionIDdocument(
            this.$route.params.transactionid,
            file.uid
          ).then(({ result, message }) => {
            this.loading = false;
            if (result) {
              this.getFileLists(this.detailData.plusuid);
            } else {
              this.$message.error(message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    filePreview(file) {
      if (
        file.contentType === this.contentType.png ||
        file.contentType === this.contentType.jpg
      ) {
        this.dialogImageUrl = file.fileDownload;
        this.dialogVisible = true;
      } else {
        this.fileDownload(file);
      }
    },
    fileDownload(file) {
      const link = document.createElement("a");
      link.href = file.fileDownload;
      link.download = file.filename;
      link.target = "_blank";
      link.click();
    },

    onSuccessUpload() {
      this.detailData.fileupload = 1;
      this.getFileLists(this.detailData.plusuid);
    },
    getComment() {
      this.commentList = [];
      this.loading = true;
      getTransactionIDComment(this.$route.params.transactionid).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            data.map((item) => {
              item.submitting = false;
              item.editing = false;
              item.canEdit = item.user === this.username;
            });
            this.commentList = data;
          }
        }
      );
    },
    getAdditionalComment() {
      this.commentAdditionalList = [];
      this.loading = true;
      getTransactionIDAdditionalComment(this.$route.params.transactionid).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            data.map((item) => {
              item.submitting = false;
              item.editing = false;
              item.canEdit = item.user === this.username;
            });
            this.commentAdditionalList = data;
          }
        }
      );
    },
    submitComment() {
      this.submittingComment = true;
      postTransactionIDComment(this.$route.params.transactionid, {
        comment: this.comment,
      }).then(({ result, message }) => {
        this.submittingComment = false;
        if (result) {
          this.$message.success("Comment submitted");
          this.getDetail();
          this.cancelAddTransactionComment();
        }
      });
    },
    cancelAddTransactionComment() {
      this.comment = "";
    },
    updateTransactionComment(item) {
      item.submitting = true;
      updateTransactionCommentByUID(
        this.$route.params.transactionid,
        item.uid,
        {
          comment: item.comment,
        }
      ).then(({ result, message }) => {
        item.submitting = false;
        if (result) {
          this.$message.success("Comment submitted");
          this.cancelUpdateTransactionComment(item);
        }
      });
    },

    editTransactionComment(item) {
      item.editing = true;
    },
    deleteTransactionComment(item) {
      this.$confirm(
        "Are you sure you want to delete this comment, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          deleteTransactionCommentByUID(
            this.$route.params.transactionid,
            item.uid
          ).then(({ result, message }) => {
            if (result) {
              this.$message.success("Comment deleted");
              this.getDetail();
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    cancelUpdateTransactionComment(item) {
      item.editing = false;
      this.getDetail();
    },
    submitAdditionalComment() {
      this.submittingCommentary = true;
      postTransactionIDAdditionalComment(this.$route.params.transactionid, {
        commentary: this.commentary,
      }).then(({ result, message }) => {
        this.submittingCommentary = false;
        if (result) {
          this.$message.success("Comment submitted");
          this.getAdditionalComment();
          this.cancelAdditionalComment();
        }
      });
    },
    cancelAdditionalComment() {
      this.commentary = "";
    },
    updateAdditionalComment(item) {
      item.submitting = true;
      updateTransactionIDAdditionalCommentByUID(
        this.$route.params.transactionid,
        item.uid,
        {
          commentary: item.comment,
        }
      ).then(({ result, message }) => {
        item.submitting = false;
        if (result) {
          this.$message.success("Comment submitted");
          this.cancelUpdateAdditionalComment(item);
        }
      });
    },

    editAdditionalComment(item) {
      item.editing = true;
    },
    deleteAdditionalComment(item) {
      this.$confirm(
        "Are you sure you want to delete this comment, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          deleteTransactionIDAdditionalCommentByUID(
            this.$route.params.transactionid,
            item.uid
          ).then(({ result, message }) => {
            if (result) {
              this.$message.success("Comment deleted");
              this.getDetail();
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    cancelUpdateAdditionalComment(item) {
      item.editing = false;
      this.getDetail();
    },
    submitSarReport() {
      if (this.detailData.sar_activity_type == "") {
        this.$alert("Please select type", "Warning");
        return false;
      }
      this.submittingSarReport = true;
      postTransactionIDCheckSarReport(this.$route.params.transactionid, {
        status: true,
        activityType: this.detailData.sar_activity_type,
      }).then(({ result, data, message }) => {
        this.submittingSarReport = false;
        if (result) {
          this.detailData.sar_report = 1;
          this.detailData.other_redflags_identified = 1;
          this.detailData.complianceReportCaseId = data.complianceReportCaseId;
          this.$message.success("Comment submitted");
        }
      });
    },
    approveStatus() {
      this.updateStatus("approve", { status: "approve" });
    },
    declineStatus() {
      if (
        this.detailData.vender === "ifx" &&
        this.detailData.paymentType === "payin"
      ){
        this.dialogDeclineIFX = true;
      }else{
        this.updateStatus("decline", { status: "decline" });
      }
    },
    submitDeclineForm(){
      this.$refs.declineForm.validate((valid) => {
          if (valid) {
            var model = JSON.parse(JSON.stringify(this.declineFormIFX))
            model.status = 'decline'

            this.updateStatus("decline", model);
          }
        });
      
    },
    updateStatus(status, data) {
      this.$confirm(`This will set status to ${status}. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          putTransactionID(this.$route.params.transactionid, data).then(
            ({ result, message }) => {
              this.loading = false;
              if (result) {
                this.$message.success("Status updated");
                this.dialogDeclineIFX = false;
                this.getDetail();
                this.$refs.declineForm && this.$refs.declineForm.resetFields();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    mapFileList(data, plusuid) {
      if (!data) return [];
      data.forEach((element) => {
        element.fileDownload = `${
          process.env.VUE_APP_SERVER_BASE_API
        }/api/firewall/media/${plusuid}/${
          element.filename
        }?token=${getToken()}`;
        if (
          element.contentType === this.contentType.png ||
          element.contentType === this.contentType.jpg
        ) {
          element.icon = "el-icon-picture";
        } else {
          element.icon = "el-icon-document";
        }

        element.name = element.originFilename;
      });
      return data;
    },
    getFileLists(plusuid) {
      getTransactionIDdocument(this.$route.params.transactionid).then(
        ({ result, data }) => {
          if (result) {
            this.fileList.sourceOfWealth = this.mapFileList(
              data.sourceOfWealth,
              plusuid
            );
            this.fileList.purposeOfPayment = this.mapFileList(
              data.purposeOfPayment,
              plusuid
            );
          }
        }
      );
    },
    dateFormat(date, format = "YYYY-MM-DD HH:mm") {
      return date ? dateFormat(date, format) : "";
    },
    getReport() {
      this.loading = true;
      getFirewallTransactionsDetail(this.$route.params.transactionid).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.detailReport = data;
          }
        }
      );
    },
    exportProfile() {
      reportFirewallProfile(this.$route.params.transactionid);
    },
  },
  mounted() {
    this.getDetail();
    this.getUtility();
  },
};
</script>

<style lang="scss" scoped>
.transaction-detail-content {
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 12px;
    margin-bottom: 10px;

    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
  .el-upload-dragger {
    padding: 20px;
  }

  .el-upload-dragger .el-upload__text {
    color: #606266;
    font-size: 14px;
    text-align: center;
    line-height: 1;
    position: absolute;
    width: 100%;
    bottom: 20px;
    font-weight: 700;
  }
  .el-upload--picture-card {
    line-height: 1 !important;
    position: relative;
  }

  .comment-content pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
    margin: 0;
  }
  .el-upload-list__item-name {
    margin-right: 0px;
  }
  .file-download {
    [class^="el-icon"] {
      color: #409eff;
    }
  }
  .file-delete {
    float: right;
    [class^="el-icon"] {
      color: #f56c6c;
    }
  }

  .el-tag {
    text-transform: capitalize;
    font-weight: 900;
    font-size: 14px;
  }
  .el-timeline {
    margin-left: -20px;
    list-style: none;
  }

  .card-comment {
    border: #e6e6e6 1px solid;
    padding: 0 10px;
    margin-bottom: 10px;
    border-radius: 3px;
    .message-comment {
      font-size: 0.8em;
      color: #606266;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-family: inherit;
      margin: 10px 0;
    }

    .info-comment {
      font-size: 11px;
      color: #97a8be;
      text-align: end;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .edit-comment {
      background-color: #ffcc12;
      padding: 3px;
      border-radius: 10px;
      color: #ecf5ff;
      cursor: pointer;
    }
    .delete-comment {
      margin-left: 3px;
      background-color: #ff3b3b;
      padding: 3px;
      border-radius: 10px;
      color: #ecf5ff;
      cursor: pointer;
    }
  }

  .auto-upload {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    .message-comment {
      color: #409eff;
    }
  }

  .label-descriptions {
    background-color: #81f845 !important;
  }
}
</style>
